import angular from 'angular';

angular
  .module('cxRelations')
  .controller('UploadRelationDocumentDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'dataCache',
    'flySvc',
    'relationId',
    'documentTypes',
    'close',
    uploadRelationDocumentDialogCtrl,
  ]);

function uploadRelationDocumentDialogCtrl(
  $element,
  $http,
  appUrls,
  dataCache,
  flySvc,
  relationId,
  documentTypes,
  close,
) {
  var vm = this;
  vm.documentTypes = documentTypes;

  vm.document = {
    relationId: relationId,
    documentType: vm.documentTypes.length === 1 ? vm.documentTypes[0] : null,
    signed: true,
    file: null,
  };
  vm.showValidation = false;

  vm.fileUploaded = function(file) {
    if (!file) return;
    vm.document.file = file;
  };
  vm.isValid = function() {
    if (vm.document.documentType === null) return false;
    if (vm.document.file === null) return false;
    return true;
  };

  vm.save = function() {
    if (!vm.isValid()) return;
    vm.saving = true;
    var data = new FormData();
    data.append('relationId', vm.document.relationId);
    data.append('documentType', vm.document.documentType);
    data.append('signed', vm.document.signed);
    data.append('data', vm.document.file.data);

    $http({
      method: 'post',
      url: appUrls.api + '/api/RelationDocument/Upload',
      headers: {
        'Content-Type': undefined,
      },
      data: data,
    })
      .then(function(response) {
        var result = response.data;
        $element.modal('hide');
        close(result, 500);
      })
      .catch(function(error) {
        flySvc.error(error.code, error.parameters);
      })
      .finally(function() {
        vm.saving = false;
      });
  };

  vm.cancel = function() {
    close(null, 500);
  };

  vm.isAdvancedUpload = (function() {
    var div = document.createElement('div');
    return (
      ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
      'FormData' in window &&
      'FileReader' in window
    );
  })();
}
